<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="width: 90%;margin-left: 5%;padding-top: 60px">
      <div class="title">
        服务领域
      </div>
      <div style="display: flex">
        <div class="name">Service field</div>
        <div style="width: 80%">
          <el-divider></el-divider>
        </div>
      </div>

<!--        <div v-html="html" style="width: 80%;margin-left: 10%"></div>-->
      </div>
      <div v-for="(item,index) in dataList" :key="index" class="article" :style="{
           backgroundColor: index%2==0?'white':'#efefef'
        }" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
        <div style="margin-left: 5%;width: 40%" v-if="index%2==0" >
          <el-image :src="item.coverImage" fit="cover" style="width: 100%"  :style="{
              transform: item.isHovered ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 0.5s ease'
            }"></el-image>
        </div>
        <div style="width: 45%;margin-left: 5%">
          <h1>{{item.title}}</h1>
          <div v-html="item.content" style="font-family: '宋体';line-height: 1.3rem">
          </div>
        </div>
        <div v-if="index%2!=0" style="margin-left: 5%;width: 40%" >
          <el-image :src="item.coverImage" fit="cover" style="width: 100%" :style="{
              transform: item.isHovered ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 0.5s ease'
            }"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getArticleDetailList} from "@/api/article";

export default {
  name: "serviceField",
  data(){
    return {
      dataList:undefined,
      queryParams:{
        category: 7,
      }
    }
  },
  mounted() {
    getArticleDetailList(this.queryParams).then(async res=>{
      const data=await  res.data.content
      for (let i = 0; i < data.length; i++) {
        data[i].isHovered=false
      }
      this.dataList=data
    })
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods:{
    changeShadow(item){
      item.isHovered=!item.isHovered
    }
  }
}
</script>

<style scoped>
.article{
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  padding-top: 20px;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 20%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.home{
  width: 100%;
  background-color: #efefef;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
</style>
